import { render, staticRenderFns } from "./incex.vue?vue&type=template&id=0ab06056&scoped=true&"
import script from "./incex.vue?vue&type=script&lang=js&"
export * from "./incex.vue?vue&type=script&lang=js&"
import style0 from "./incex.vue?vue&type=style&index=0&id=0ab06056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab06056",
  null
  
)

export default component.exports